/*
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.exceptionDetailDialog = new ExceptionDetailDialog();
        }
*/
import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { ObjectHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/ObjectHelper";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { WebApiClientService } from "@seriously-rad/seriouslyrad-framework-core/Server/WebApiClientService";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { ButtonStyleEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ButtonStyleEnum";
import { MessageDialog } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/MessageDialog";
import { DialogResultEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Dialogs/DialogResultEnum";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandProcessInstanceTerminatePropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandProcessInstanceTerminateProperties = {
    [name in keyof EntityCommandProcessInstanceTerminatePropertyValues]: Property<EntityCommandProcessInstanceTerminatePropertyValues[name]>
};

export interface IEntityCommandProcessInstanceTerminate extends IEntityCommand, EntityCommandProcessInstanceTerminateProperties
{
}

export class EntityCommandProcessInstanceTerminate extends EntityCommand implements IEntityCommandProcessInstanceTerminate
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandProcessInstanceTerminate";
    public static override className = "EntityCommandProcessInstanceTerminate";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandProcessInstanceTerminatePropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Terminate",
                entityName: "ProcessInstance",
                key: "TERMINATE",
                permission: PermissionEvaluator.permissionLevels.update,
                type: EntityCommandTypeEnum.entity,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandProcessInstanceTerminatePropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    const
                        recordId = entityCommandInformation.getRecordId();

                    if (!recordId)
                        return;

                    return (
                        MessageDialog.displayMessage("Terminate Process Instance", "Are you sure you want to terminate the process instance?", ButtonStyleEnum.yesNo)
                            .then(result =>
                            {
                                if (result.dialogResult !== DialogResultEnum.yes)
                                    return;

                                return (
                                    ServiceManager.getRequired(WebApiClientService)
                                        .createApiMethodRequest("DataService", "CallDataService", { id: "b185975f-0e14-4944-b706-6353f0d67dc4", operation: "TerminateProcessInstance", data: ObjectHelper.toJson({ processInstanceId: recordId }) })
                                        .executeAsync()
                                );
                            })
                    );
                })
        );
    }

    // #endregion

    // #endregion
}

